<script>
  import { Bar } from 'vue-chartjs'

  export default {
    extends: Bar,
    props: {
      mergedOptions:{
        type: Object
      },
      mergedData:{
        type: Object,
        required: true
      }
    },
    mounted () {
      this.renderChart(this.chartdata, this.options)
    },
    watch: {
      mergedData() {
        // Re-render the chart whenever mergedData changes.
        this.renderChart(this.chartdata, this.options)
      },
      mergedOptions() {
        // Re-render the chart whenever mergedOptions changes.
        this.renderChart(this.chartdata, this.options)
      }
    },
    data() {
      return {
        // defaultBackgroundColor: [
        //   "rgba(247, 147, 30, 0.4)",
        //   "rgba(159, 139, 104, 0.4)",
        //   "rgba(139, 3, 44, 0.4)"
        // ]
        defaultBackgroundColor: "rgba(244, 99, 58, 0.4)"
      }
    },
    computed: {
      chartdata() {
        // TODO: Fix warning re "unexpected side effects"
        this.mergedData.datasets[0].backgroundColor = this.defaultBackgroundColor
        return this.mergedData
      },
      options() {
        return this.mergedOptions
      }
    }
  }
</script>
